import { Card, CardContent, Typography, Stack, Box } from "@mui/material";
import { motion } from "framer-motion";
import { GitHub, Instagram, LinkedIn } from "@mui/icons-material";

const TeamCard = ({ member, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 50 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5, delay: index * 0.1 }}
    whileHover={{ y: -10 }}
  >
    <Card
      sx={{
        width: { xs: "100%", sm: 300 },
        height: { xs: "auto", sm: 380 },
        borderRadius: "4px",
        backgroundColor: "#001d3d",
        border: "1px solid rgba(255,255,255,0.12)",
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
        overflow: "hidden",
        transition: "all 0.3s ease",
        "&:hover": { boxShadow: "0 12px 28px rgba(0,0,0,0.4)" },
      }}
    >
      <Box sx={{ height: { xs: 180, sm: 200 }, position: "relative", overflow: "hidden", borderTopLeftRadius: "4px", borderTopRightRadius: "4px" }}>
        <Box
          component="img"
          src={member.image}
          alt={member.name}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            transition: "transform 0.5s ease",
            "&:hover": { transform: "scale(1.05)" },
          }}
        />
      </Box>
      <CardContent sx={{ textAlign: "center" }}>
        <Typography variant="h6" fontWeight={700} gutterBottom sx={{ color: "#fff", fontSize: "1.1rem" }}>
          {member.name}
        </Typography>
        <Typography variant="subtitle1" fontWeight={600} gutterBottom sx={{ color: "rgba(255,255,255,0.8)", fontSize: "0.9rem" }}>
          {member.role}
        </Typography>
        <Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 2 }}>
          {member.socials.github && (
            <a href={member.socials.github} target="_blank" rel="noopener noreferrer">
              <GitHub sx={{ color: "rgba(255,255,255,0.8)", "&:hover": { color: "#fff" } }} />
            </a>
          )}
          {member.socials.instagram && (
            <a href={member.socials.instagram} target="_blank" rel="noopener noreferrer">
              <Instagram sx={{ color: "rgba(255,255,255,0.8)", "&:hover": { color: "#fff" } }} />
            </a>
          )}
          {member.socials.linkedin && (
            <a href={member.socials.linkedin} target="_blank" rel="noopener noreferrer">
              <LinkedIn sx={{ color: "rgba(255,255,255,0.8)", "&:hover": { color: "#fff" } }} />
            </a>
          )}
        </Stack>
      </CardContent>
    </Card>
  </motion.div>
);

export default TeamCard;